// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardHeader_wrapper__fS7Tx","header":"DashboardHeader_header__l-yjg"};